// Mock data for Sahiwal Farms

export const heroData = {
  headline: "Where Excellence in Dairy Meets the Legacy of Champions",
  subheading: "Premium Dairy Production & Elite Horse Stud Farming with Generations of Excellence.",
  backgroundImage: require("./images/crop.jpeg"),
  videoUrl: null // Can be replaced with actual video
};

export const aboutData = {
  title: "Heritage of Excellence",
  description: "Since 1947, Sahiwal Farms has been at the forefront of premium agricultural practices, combining time-honored traditions with cutting-edge farming techniques. Our commitment to animal welfare, sustainable farming, and breeding excellence has made us a trusted name in both dairy production and elite horse breeding.",
  highlights: [
    "Family-owned heritage since 1947",
    "Sustainable and ethical farming practices",
    "Award-winning dairy cattle and thoroughbred horses",
    "Modern facilities with traditional values",
    "Certified organic dairy production",
    "Champion bloodlines in horse breeding"
  ],
  image: require("./images/cow7.jpeg"),
};

export const servicesData = [
  {
    id: 1,
    title: "Premium Dairy Farming",
    description: "Our state-of-the-art dairy facilities produce the finest quality milk from healthy, well-cared-for cattle. We employ sustainable practices and modern technology to ensure the highest standards.",
    features: [
      "Fresh Organic Milk Production",
      "Healthy Dairy Cattle Management",
      "Quality Feed & Nutrition Programs",
      "24/7 Veterinary Care",
      "Advanced Milking Systems",
      "Sustainable Farming Practices"
    ],
    image: require("./images/cow10.jpeg"),
    icon: "Milk"
  },
  {
    id: 2,
    title: "Elite Horse Stud Farm",
    description: "Home to champion bloodlines and thoroughbred excellence. Our horse breeding program combines genetics, expert care, and training to produce winners.",
    features: [
      "Premium Horse Breeding Programs",
      "Champion Stallion Services",
      "Expert Mare Care & Management",
      "Professional Foal Development",
      "Advanced Training Facilities",
      "Comprehensive Veterinary Care"
    ],
    image: require("./images/horse7.jpg"),
    icon: "Horse"
  }
];

export const featuredLivestock = {
  cattle: [
    {
      id: 1,
      name: "Royal Queen",
      breed: "Holstein Friesian",
      age: "4 years",
      production: "35L/day",
      health: "Excellent",
      image: require("./images/cow1.jpeg")
    },
    {
      id: 2,
      name: "Golden Lady",
      breed: "Jersey",
      age: "3 years",
      production: "28L/day",
      health: "Excellent",
      image: require("./images/cow9.jpeg")
    },
    {
      id: 3,
      name: "Pride of Sahiwal",
      breed: "Sahiwal",
      age: "5 years",
      production: "32L/day",
      health: "Excellent",
      image: require("./images/cow7.jpeg")
    }
  ],
  horses: [
    {
      id: 1,
      name: "Thunder Champion",
      breed: "Thoroughbred",
      bloodline: "Eclipse Line",
      achievements: "3x Regional Champion",
      image: require("./images/horse6.jpeg"),
    },
    {
      id: 2,
      name: "Golden Spirit",
      breed: "Arabian",
      bloodline: "Desert Pride",
      achievements: "National Show Winner",
      image: require("./images/horse8.jpg"),
    },
    {
      id: 3,
      name: "Midnight Star",
      breed: "Thoroughbred",
      bloodline: "Northern Dancer",
      achievements: "Derby Finalist",
      image: require("./images/horse3.jpeg"),
    }
  ]
};

export const galleryData = {
  dairyFarm: [
    require("./images/cow4.jpeg"),
    require("./images/cow5.jpeg"),
    require("./images/cow6.jpeg"),
    require("./images/cow7.jpeg"),
    require("./images/cow8.jpeg"),
    require("./images/cow9.jpeg"),
    require("./images/cow10.jpeg"),
    require("./images/cow11.jpeg"),
    require("./images/cow1.jpeg"),
    require("./images/cow2.jpeg"),
    require("./images/cow3.jpeg"),
  ],
  horseStud: [
    require("./images/horse7.jpg"),
    require("./images/horse8.jpg"),
    require("./images/horse9.jpg"),
    require("./images/horse1.jpeg"),
    require("./images/horse2.jpeg"),
    require("./images/horse3.jpeg"),
    require("./images/horse4.jpeg"),
    require("./images/horse5.jpeg"),
    require("./images/horse6.jpeg"),
  ],
  facilities: [
    require("./images/cow7.jpeg"),
    require("./images/horse7.jpg"),


  ],
  landscape: [
    require("./images/coverpic.jpeg"),
    require("./images/farm2.jpeg"),
    require("./images/farm3.jpeg"),
    require("./images/crop.jpeg"),

  ]
};

export const statsData = [
  { label: "Established", value: 1947, suffix: "" },
  { label: "Happy Clients", value: 500, suffix: "+" },
  { label: "Premium Cattle", value: 100, suffix: "+" },
  { label: "Elite Horses", value: 40, suffix: "+" },
  { label: "Acres of Land", value: 15, suffix: "+" }
];

export const testimonialsData = [
  {
    id: 1,
    name: "Sarah Mitchell",
    role: "Dairy Products Distributor",
    content: "Sahiwal Farms has been our trusted partner for over 15 years. The quality of their dairy products is unmatched, and their commitment to animal welfare is truly commendable.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330"
  },
  {
    id: 2,
    name: "James Patterson",
    role: "Horse Breeder",
    content: "I've bred horses with Sahiwal Farms' champion stallions for years. The bloodlines are exceptional, and the care they provide is world-class. Highly recommended!",
    rating: 5,
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d"
  },
  {
    id: 3,
    name: "Emily Rodriguez",
    role: "Organic Food Retailer",
    content: "The organic dairy products from Sahiwal Farms are the cornerstone of our business. Our customers love the quality and taste. A fantastic partnership!",
    rating: 5,
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80"
  }
];

export const teamData = [
  {
    id: 1,
    name: "Rana Naveed Jabbar",
    role: "Farm Owner",
    contact: "Contact No#: +92 321 8698134",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e"
  },
  {
    id: 2,
    name: "Muhammad Abdullah",
    role: "General Manager & Contractor",
    contact: "Contact No#: +92 309 6515914",
    image: "https://images.unsplash.com/photo-1559839734-2b71ea197ec2"
  },


];

export const whyChooseData = [
  {
    id: 1,
    title: "Sustainable Agriculture",
    description: "We practice eco-friendly farming methods that preserve our land for future generations while producing premium quality products.",
    icon: "Leaf"
  },
  {
    id: 2,
    title: "Expert Veterinary Care",
    description: "24/7 professional veterinary support ensures the health and wellbeing of every animal on our farm.",
    icon: "Stethoscope"
  },
  {
    id: 3,
    title: "Elite Bloodlines",
    description: "Our breeding program features champion genetics and proven bloodlines that produce consistent winners.",
    icon: "Award"
  },
  {
    id: 4,
    title: "Trusted Quality",
    description: "Three generations of excellence have built our reputation for delivering the finest dairy products and horses.",
    icon: "Shield"
  }
];

export const manifestoData = [
  {
    number: "01",
    title: "Heritage",
    content: "Since 1947, our legacy spans three generations of passionate farmers committed to quality and tradition."
  },
  {
    number: "02",
    title: "Innovation",
    content: "We blend time-honored practices with cutting-edge technology, creating a perfect harmony of tradition and modern efficiency."
  },
  {
    number: "03",
    title: "Welfare",
    content: "Every animal in our care receives premium treatment, proper nutrition, and a stress-free environment that promotes natural health."
  },
  {
    number: "04",
    title: "Excellence",
    content: "From dairy production to horse breeding, we pursue perfection in every aspect, setting industry standards for quality and care."
  }
];
